/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessSector } from '../../models/business-sector';

export interface GetBusinessSectors$Params {

/**
 * piaRelated only
 */
  piaRelated?: boolean;
}

export function getBusinessSectors(http: HttpClient, rootUrl: string, params?: GetBusinessSectors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BusinessSector>>> {
  const rb = new RequestBuilder(rootUrl, getBusinessSectors.PATH, 'get');
  if (params) {
    rb.query('piaRelated', params.piaRelated, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BusinessSector>>;
    })
  );
}

getBusinessSectors.PATH = '/businessSectors';
